module.exports = __webpack_public_path__ + "fonts/MoskauGrotesk-Light.74f9ed0c.ttf";